import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'cutText'
})
export class CutTextPipe implements PipeTransform {

  transform(value: string, args?: any): any {
    if (!value) {
      return '';
    }
    let shortText = '';
    const maxLength = args ? args : 180;
    const stringLength = value.length;
    if (value) {
      shortText = value.toString().replace(/<\/?[^>]+(>|$)/g, '');
      shortText = shortText.replace(/^(.{' + n + '}[^\s]*).*/, '$1');
      shortText = shortText.substr(0, maxLength);
      if (stringLength > maxLength) {
        shortText = shortText + ' ... ';
      }
    }
    return shortText;
  }

}
